import { getPreventDefaultHandler, someNode, toggleNodeType } from '@udecode/plate';
import { useEditorState } from '@udecode/plate';
import * as React from 'react';

import { ToolbarButton, ToolbarButtonProps } from '../toolbar-button';

export interface ToolbarElementProps extends Omit<ToolbarButtonProps, 'active'> {
  type: string;
  inactiveType?: string;
  icon: React.ReactNode;
  onSelect?: () => void;
}

export const ToolbarElement = ({
  type,
  inactiveType,
  icon,
  label,
  tooltip,
  btnRef,
  onSelect,
  ...otherProps
}: ToolbarElementProps): JSX.Element => {
  const editor = useEditorState();
  return (
    <ToolbarButton
      active={someNode(editor, { match: { type } })}
      icon={icon}
      label={label}
      tooltip={tooltip}
      btnRef={btnRef}
      onMouseDown={getPreventDefaultHandler(toggleNodeType, editor, {
        activeType: type,
        inactiveType,
      })}
      onClick={onSelect}
      {...otherProps}
    />
  );
};
